import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { createOffersHistoryListingMapper, TMappedResponse } from './mappers';
import {
  fetchGetHouseOfferHistoryByHouseId,
  TGetHouseOfferHistoryByHouseIdRequest,
  TGetHouseOfferHistoryByHouseIdResponse
} from '../../../repositories/valuation-offer-history/v1/get-house-offer-history-by-house-id';
import { IThunkContext } from '../../../types/redux';
import {
  fetchGetHouseOfferHistoryDesktop,
  TGetHouseOfferHistoryDesktopRequest,
} from '../../../repositories/valuation-offer-history/v4/get-house-offer-history-desktop';
import { prepareOffersHistory } from '../mappers';
import { EDealType } from '../../../types/dealType';
import {
  IOfferHistoryResponseBaseV4
} from "../../../repositories/valuation-offer-history/entities/offer_history/OfferHistoryResponseBaseV4";

export const fetchOffersHistoryListingByHouseId = async (
  context: IThunkContext,
  parameters: TGetHouseOfferHistoryByHouseIdRequest,
) => {
  try {
    const res = (await fetchGetHouseOfferHistoryByHouseId({
      httpApi: context.httpApi,
      parameters,
      mappers: createOffersHistoryListingMapper(parameters),
    })) as TMappedResponse;

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('get-house-offer-history-desktop BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in get-house-offer-history-desktop', ...parameters });
    }

    throw error;
  }
};

export const fetchOffersHistoryListingByOfferId = async (
  context: IThunkContext,
  parameters: TGetHouseOfferHistoryDesktopRequest,
) => {
  try {
    const res = (await fetchGetHouseOfferHistoryDesktop({
      httpApi: context.httpApi,
      parameters,
    })) as TGetHouseOfferHistoryByHouseIdResponse;

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        domain: 'fetchOffersHistoryListing.ts',
        statusCode: 400,
        message: res.response.message || /* istanbul ignore next */ '',
        details: { ...parameters },
      });
    }

    /**
     * Приводим тип к нужному в маппере - апи OfferHistoryByHouseId отдает идентичный ответ
     */
    return prepareOffersHistory(
      res.response as unknown as IOfferHistoryResponseBaseV4,
      parameters.dealType as EDealType,
    );
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('get-house-offer-history-desktop BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in get-house-offer-history-desktop', ...parameters });
    }

    throw error;
  }
};
